import React from 'react';

function Bracket({children, onCollapse, ...props}) {
  return (
    <span onDoubleClick={onCollapse} {...props}>
      <span style={{fontSize: 20, marginRight: 10}}>(</span>
      {children}
      <span style={{fontSize: 20, marginLeft: 10}}>)</span>
    </span>
  );
}

export default Bracket;
